import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#F79406",
        secondary: "#4CFF33",
        accent: "#4CFF33",
        error: "#4CFF33",
        background: "#fffffff80"
      },
      dark: {
        primary: "#F79406",
        secondary: "#4CFF33",
        accent: "#4CFF33",
        error: "#4CFF33",
        background: "#6164c7"
      }
    },
    dark: false
  },
  icons: {
    iconfont: "mdi"
  }
});
